<script lang="ts" setup>
  import type { ICloseArgs } from '#shared/types/modal.types';
  import type { TCashierTab } from '~/store/cashier';
  import { CashierDepositTab, CashierWithdrawTab } from '#components';
  import { ECashierTab } from '~/store/cashier';

  const props = withDefaults(
    defineProps<{
      tabName?: string;
    }>(),
    {
      tabName: ECashierTab.Deposit,
    },
  );

  const emit = defineEmits<{ close: [ICloseArgs] }>();
  const tabs = Object.values(ECashierTab) as TCashierTab[];

  const deviceType = useDeviceType();
  const useFullscreenMode = computed(() => {
    return deviceType.isPortraitMobile.value && deviceType.activeBreakpoint.value !== 'sm';
  });

  const activeTab = ref(props.tabName);
  const activeTabComponent = computed(() =>
    activeTab.value === ECashierTab.Deposit ? CashierDepositTab : CashierWithdrawTab,
  );

  function closeModal() {
    emit('close', {});
  }
</script>

<template>
  <UModal
    title="Cashier"
    description="Deposit or withdraw your money"
    :close="{ onClick: closeModal }"
    :ui="{
      content: 'overflow-y-hidden w-[100%] md:w-[417px] bg-[#242B34]',
    }"
    :fullscreen="useFullscreenMode"
  >
    <template #content>
      <div class="overflow-auto bg-[#252a33]">
        <UIcon
          name="mdi-close"
          class="cursor-pointer absolute z-10 right-2 top-1 size-6 text-white xs:block"
          @click="closeModal"
        />
        <div class="flex flex-col items-center justify-start">
          <!-- tabs -->
          <div class="flex items-center justify-center w-full bg-[#0d1117]">
            <div
              v-for="tab in tabs"
              :key="tab"
              class="flex basis-full h-[50px] py-4 justify-center items-center gap-2.5 bg-gradient-to-b from-[#0C1117] to-[#0C1117] bg-[#48515C] text-white text-center font-barlow text-[18px] leading-[18px] tracking-[0.36px] nth-[1]:rounded-tl-[4px] nth-[1]:rounded-tr-[10px] nth-[2]:rounded-tl-[10px] nth-[2]:rounded-tr-[4px]"
              :class="{
                'bg-gradient-to-b from-[#242B34] to-[#242B34] bg-[#48515C] font-bold': activeTab === tab,
                'font-medium opacity-50 cursor-pointer': activeTab !== tab,
              }"
              @click="activeTab = tab"
            >
              {{ tab }}
            </div>
          </div>

          <!-- tab content -->
          <component :is="activeTabComponent" class="mb-6" @close="closeModal" />
        </div>
      </div>
    </template>
  </UModal>
</template>
